<template>
  <div
    class="max-h-[308px] overflow-y-auto px-2 py-2"
    data-test="popover-scroll"
  >
    <slot />
  </div>
</template>
